"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhitelistState = exports.ProposalState = exports.PoolTokenType = exports.Factory = exports.Networks = void 0;
var Networks;
(function (Networks) {
    Networks["Ropsten"] = "ropsten";
    Networks["Mainnet"] = "mainnet";
    Networks["Polygon"] = "polygon";
    Networks["Arbitrum"] = "arbitrum";
    Networks["Avalanche"] = "avalanche";
    Networks["Moonriver"] = "moonriver";
    Networks["Aurora"] = "aurora";
    Networks["Cronos"] = "cronos";
    Networks["Fantom"] = "fantom";
    Networks["Harmony"] = "harmony";
    Networks["Moonbeam"] = "moonbeam";
    Networks["Sxnetwork"] = "sxnetwork";
    Networks["Canto"] = "canto";
    Networks["ZksyncEra"] = "zksync-era";
    Networks["Blast"] = "blast";
    Networks["Base"] = "base";
    Networks["Mantle"] = "mantle";
    Networks["Scroll"] = "scroll";
    Networks["Optimism"] = "optimism";
    Networks["Real"] = "re.al";
    Networks["Sonic"] = "sonic";
    Networks["Linea"] = "linea";
})(Networks = exports.Networks || (exports.Networks = {}));
// FACTORIES
var Factory;
(function (Factory) {
    Factory["V2V1"] = "1";
    Factory["V2V1_1"] = "2";
    Factory["V2V1_2"] = "3";
    Factory["V2V2"] = "4";
    Factory["SOLV1_2"] = "5";
    Factory["SOLV2"] = "6";
    Factory["SOL_STABLE"] = "7";
})(Factory = exports.Factory || (exports.Factory = {}));
var PoolTokenType;
(function (PoolTokenType) {
    PoolTokenType["Collateral"] = "collateral";
    PoolTokenType["BorrowableA"] = "borrowable0";
    PoolTokenType["BorrowableB"] = "borrowable1";
})(PoolTokenType = exports.PoolTokenType || (exports.PoolTokenType = {}));
var ProposalState;
(function (ProposalState) {
    ProposalState["Pending"] = "Pending";
    ProposalState["Approved"] = "Approved";
    ProposalState["Rejected"] = "Rejected";
})(ProposalState = exports.ProposalState || (exports.ProposalState = {}));
;
var WhitelistState;
(function (WhitelistState) {
    WhitelistState[WhitelistState["Unlisted"] = 0] = "Unlisted";
    WhitelistState[WhitelistState["Listed"] = 1] = "Listed";
    WhitelistState[WhitelistState["Deprecated"] = 2] = "Deprecated";
    WhitelistState[WhitelistState["Blacklisted"] = 3] = "Blacklisted";
})(WhitelistState = exports.WhitelistState || (exports.WhitelistState = {}));
;
